/**
 * API 接口统一管理
 * 所有请求地址在此集中配置，避免硬编码散落各组件
 */

import axios from 'axios'
import qs from 'qs'

// ===================== 基础域名 =====================
const BASE_W    = 'https://w.gtea.icu'
const BASE_DOC  = 'https://doc.gtea.icu'
const BASE_IMGAPI = 'http://w.gtea.icu:21280'

const COVER_API = 'https://w.gtea.icu/zmhapi.php'

// ===================== axios 实例 =====================
const http = axios.create({ timeout: 10000 })

// 统一 POST 使用表单格式
http.interceptors.request.use(config => {
  if (config.method === 'post' && typeof config.data === 'object') {
    config.data = qs.stringify(config.data)
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
  }
  return config
})

// ===================== 嵌字任务 =====================

/** 获取嵌字任务列表 */
export const getZmbList = () =>
  http.get(`${BASE_W}/getdata.php`)

/** 嵌字任务接单
 * @param {number|string} id   任务 ID
 * @param {string}        user 接单人署名
 */
export const takeZmbTask = (id, user) =>
  http.post(`${BASE_W}/getw.php`, { id, user })

/** 发布嵌字任务
 * @param {Object} data 任务表单数据
 */
export const publishZmbTask = (data) =>
  http.post(`${BASE_W}/fabu.php`, data)

// ===================== 翻译任务 =====================

/** 获取翻译任务列表 */
export const getFyList = () =>
  http.get(`${BASE_W}/fygetdata.php`)

/** 翻译任务接单 */
export const takeFyTask = (id, user) =>
  http.post(`${BASE_W}/fygetw.php`, { id, user })

/** 发布翻译任务 */
export const publishFyTask = (data) =>
  http.post(`${BASE_W}/fyfabu.php`, data)

// ===================== 辅助接口 =====================

/** 通过漫画网址自动获取封面图 URL
 * @param {string} url 漫画列表页网址
 * @returns {Promise<Object>} 漫画信息
 */
export const fetchCoverUrl = (url) => {
  const comicId = extractComicId(url)
  return http.get(COVER_API, { params: { comicId } })
}

function extractComicId(url) {
  const value = String(url || '').trim()
  if (!value) {
    throw new Error('EMPTY_URL')
  }

  try {
    const { pathname } = new URL(value)
    const match = pathname.match(/(\d+)(?:\/?$)/)
    if (match) {
      return match[1]
    }
  } catch (e) {
    // ignore parse error and fallback to generic match
  }

  const fallbackMatch = value.match(/(\d+)(?!.*\d)/)
  if (fallbackMatch) {
    return fallbackMatch[1]
  }

  throw new Error('INVALID_COMIC_URL')
}

// ===================== 留言板 =====================

/** 获取所有留言 */
export const getMsgList = () =>
  http.get(`${BASE_DOC}/notesql/getlist.php`)

/** 提交留言
 * @param {string} username 署名
 * @param {string} msg      留言内容
 * @param {string} skey     登录 key（预留）
 */
export const addMsg = (username, msg, skey = '') =>
  http.get(`${BASE_DOC}/notesql/add.php`, { params: { username, msg, skey } })



// WEBPACK FOOTER //
// ./src/api/index.js